import React, { Component } from "react";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import ReactHighcharts from "react-highcharts";
import seriesColor from "../../../../utils/seriesColor";
import moment from "moment";
import ChartWithSyncedZoom from '../ChartWithSyncedZoom/ChartWithSyncedZoom';
import { number, deepClone, shouldUpdate, tooltip, units } from "../../../../utils";
import { actions as chartTooltipActions } from "../ChartTooltip/redux";
import { actions as chartCommentActions } from "../../../ChartComment/redux";
import ToggleChartSeries from '../../../ToggleChartSeries/ToggleChartSeries';
import ChartComment from '../../../ChartComment/ChartComment';

import styles from "./styles.scss";

const dateFormat = "dddd, MMM Do, h:mm A";

const config = {
	chart: {
		animation: false,
		zoomType: "x",
		panning: true,
		panKey: "shift",
		marginBottom: 110,
		alignTicks: false,
		responsive: true,
		maintainAspectRatio: false,
		style: {
			fontFamily: "Helvetica"
		}
	},
	credits: {
		enabled: false
	},
	colors: seriesColor.getSeriesColors(),
	title: {
		text: "Run Times and Failures",
		align: "left",
		margin: 60,
		style: {
			color: "#4D4D4D",
			"font-size": "20px",
			"font-weight": "600"
		}
	},
	plotOptions: {
		line: {
			dataGrouping: {
				enabled: false,
				groupAll: true
			},
			turboThreshold: 0
		}
	},
	tooltip: {
		enabled: false,
		shared: true,
		formatter: function() {
			var s =
				'<span style="font-size:10px">' +
				moment(this.x)
					.utc()
					.format(dateFormat) +
				"</span>";

			this.points.forEach(point => {
				s +=
					'<br /><b><span style="color:' +
					point.point.color +
					'">' +
					point.series.name +
					":</span></b> " +
					(point.point.desc
						? "<br />" + point.point.desc.replace("\n", "<br />").replace("\r", "<br />")
						: number.parseNumber(point.y) + " " + units.getUnitName(point.point.options.units));
			});

			return s;
		}
	},
	legend: {
		floating: false,
		itemStyle: {
			color: "#999",
			fontWeight: "normal",
			fontSize: "14px"
		},
		align: "center",
		verticalAlign: "bottom",
		layout: "horizontal"
	},
	xAxis: {
		type: "datetime",
		tickWidth: 0,
		lineColor: "#e6e6e6",
		labels: {
			y: 30,
			style: {
				fontSize: "14px",
				color: "#999"
			}
		},
		dateTimeLabelFormats: {
			hour: "%l%P",
			day: "%e %b"
		}
	},
	responsive: {
		rules: [
			{
				condition: {
					maxWidth: 700
				},
				chartOptions: {
					chart: {
						marginBottom: 190
					}
				}
			},
			{
				condition: {
					minWidth: 700,
					maxWidth: 870
				},
				chartOptions: {
					chart: {
						marginBottom: 170
					}
				}
			},
			{
				condition: {
					minWidth: 870,
					maxWidth: 1000
				},
				chartOptions: {
					chart: {
						marginBottom: 150
					}
				}
			},
			{
				condition: {
					minWidth: 1000,
					maxWidth: 1300
				},
				chartOptions: {
					chart: {
						marginBottom: 130
					}
				}
			},
			{
				condition: {
					minWidth: 1300
				},
				chartOptions: {
					chart: {
						marginBottom: 110
					}
				}
			}
		]
	},
	series: []
};

@CSSModules(styles, { allowMultiple: true })
class ValidationRuleOutsideOffsetChart extends Component {
	constructor(props) {
		super(props);
		this.id = tooltip.uuidv4();
		this.chart = React.createRef();
		this.config = deepClone(config);
		this.config.title.text = this.props.component.chartTitle || this.config.title.text;
		this.onChartMouseMove = this.onChartMouseMove.bind(this);
		this.onChartMouseClick = this.onChartMouseClick.bind(this);
	}

	render() {
		return(
			<div id={this.id} style={{position: 'relative'}}>
				<ReactHighcharts config={this.config} ref={this.chart} isPureConfig={false} />
				<ChartComment chart={this.chart} timePeriod={this.props.timePeriod} />
				<ToggleChartSeries chart={this.chart} />
			</div>
		);
	}

	setup() {
		let chart = this.chart.current.getChart();
		this.props.loadData(this.props.component, chart, this.props.timePeriod, this.props.onLoadComplete, this.id);
		setTimeout(() => {
		   if(chart) {
			  chart.reflow();
			  chart.redraw();
		   }
		}, 100);

		var x = document.getElementById(this.id).childNodes[0].childNodes[0];
		x.addEventListener("mousemove", this.onChartMouseMove);
		x.addEventListener("click", this.onChartMouseClick);
	}

	componentDidMount() {
		this.setup();
	}

	onChartMouseMove(e) {
		e = this.chart.current.chart.pointer.normalize(e);

		let x = Math.floor(this.chart.current.chart.xAxis[0].toValue(e.chartX));
		let isIn = this.chart.current.chart.isInsidePlot(e.chartX - this.chart.current.chart.plotLeft, e.chartY - this.chart.current.chart.plotTop);

		this.props.mouseMovedInContainer(e, x, isIn, moment().valueOf(), this.id);
	}

	onChartMouseClick(e) {
		this.chart.current.chart.pointer.normalize(e);

		let extremes = this.chart.current.chart.yAxis[0].getExtremes();
		let y = Math.floor(this.chart.current.chart.yAxis[0].toValue(e.chartY));
	
		var range = extremes.max - extremes.min;
		var perc = Math.floor(((y - extremes.min) / range) * 100);

		let x = Math.floor(this.chart.current.chart.xAxis[0].toValue(e.chartX));

		this.props.chartClicked(x, Math.abs(perc));
	}

	componentWillUnmount() {
		var x = document.getElementById(this.id).childNodes[0].childNodes[0];
		x.removeEventListener("mousemove", this.onChartMouseMove);
		x.removeEventListener("click", this.onChartMouseClick);
		this.props.mouseRemove(this.id);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
        console.log('update')
		this.setup();
	}

	shouldComponentUpdate(nextProps, nextState) {
		return shouldUpdate(this, nextProps, nextState, ["onLoadComplete"]);
	}
}

const bindAction = dispatch => {
	return {
		loadData: (component, chart, timePeriod, onLoadComplete, id) => dispatch(actions.loadData(component, chart, timePeriod, onLoadComplete, id)),
		mouseMovedInContainer: (e, x, isIn, now, id) => dispatch(chartTooltipActions.mouseMovedInContainer(e, x, isIn, now, id)),
		mouseRemove: (id) => dispatch(chartTooltipActions.remove(id)),
		chartClicked: (x, y) => dispatch(chartCommentActions.chartClicked(x, y)),
	};
};

const mapStateToProps = (state, ownProps) => ({
	commentUpdate: state.chartcomment.commentUpdate,
});

export default connect(
	mapStateToProps,
	bindAction
)(ChartWithSyncedZoom(ValidationRuleOutsideOffsetChart));


// WEBPACK FOOTER //
// ./src/components/ReportComponents/Charts/ValidationRuleOutsideOffsetChart/ValidationRuleOutsideOffsetChart.js